import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "spark_desktop_install_dismissed";

export const DesktopInstallPrompt = () => {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (localStorage.getItem(DISMISS_KEY)) return;
      if (window.matchMedia("(display-mode: standalone)").matches) return;
      if (window.innerWidth < 1024) return;
    } catch { return; }
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    setVisible(false);
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* ignore */ }
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try { await deferred.userChoice; } catch { /* user closed */ }
    setVisible(false);
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch { /* ignore */ }
  };

  return (
    <div
      className="hidden lg:block fixed bottom-6 right-6 z-[70] w-[340px] rounded-2xl bg-[#1E1F23] border border-[#C9A961]/30 shadow-2xl shadow-black/60"
      data-testid="desktop-install-prompt"
    >
      <div className="p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#C9A961]/12 border border-[#C9A961]/30 flex items-center justify-center shrink-0">
            <Download className="w-4.5 h-4.5 text-[#C9A961]" strokeWidth={2.2} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-display text-[15px] font-medium text-[#F0E6D2] leading-tight">
              Want Spark on your computer?
            </div>
            <div className="text-[12px] text-[#A0A0A8] mt-1 leading-relaxed">
              Install the app for faster access — its own window, dock icon, no browser tabs.
            </div>
          </div>
          <button
            onClick={dismiss}
            className="shrink-0 w-6 h-6 rounded-full flex items-center justify-center text-[#8C867C] hover:text-[#F0E6D2] hover:bg-white/[0.06] transition"
            aria-label="Dismiss"
            data-testid="desktop-install-dismiss"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
        <div className="flex gap-2 mt-3">
          <button
            onClick={install}
            className="flex-1 bg-[#C9A961] text-[#16171A] rounded-full py-2 text-xs font-bold uppercase tracking-wider active:scale-95 hover:bg-[#D4B571] transition"
            data-testid="desktop-install-btn"
          >
            Install app
          </button>
          <button
            onClick={dismiss}
            className="px-4 rounded-full py-2 text-xs font-bold uppercase tracking-wider text-[#A0A0A8] bg-white/[0.06] active:scale-95 transition"
            data-testid="desktop-install-later"
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
};
